import { Injectable } from '@angular/core';
import { companyConfigService } from './core/services/company-config.service';
import { HttpClient } from '@angular/common/http';
import { delay, firstValueFrom, forkJoin } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppConstants_settings } from './core/AppConstants_Appsettings.enum';
import { ICompanyconfigModel } from './models/config-model';
import { environment } from '../environments/environment';

@Injectable({ providedIn: 'root' })
export class AppInitService {
  configmodel: ICompanyconfigModel = {
    CompanyConfig: {},
    DBConfig: {},
  };
  constructor(
    private http: HttpClient,
    private companyConfigService: companyConfigService,
    private store: Store
  ) {
    console.log('==================================>Current Environment is [' + environment.Environment + '] <===================================');
  }

  init(): Promise<void> {
    return firstValueFrom(
      forkJoin({
        dbConfig: this.http.get(
          AppConstants_settings.BACKOFFICE_URL + '/Login/GetWebsiteData'
        ).pipe(delay(500)),
        companyConfig: this.http.get('/assets/company-config.json').pipe(delay(500)),
      })
    ).then(({ dbConfig, companyConfig }) => {
      this.companyConfigService.setDbConfig(dbConfig);
      this.companyConfigService.setCompanyConfig(companyConfig);
      // console.log('companyConfig',this.companyConfigService.getConfig());
      const loader = document.getElementById('app-loading');
      if (loader) {
        loader.classList.add('fade-out');
        setTimeout(() => loader.remove(), 500); // remove after fade
      }
    });
  }
}
